export const environment = {
    NAME: 'stage4',
    APP_NAME: 'nucleus',
    APP_MODE: 'default',
    APP_NAMESPACE: 'n',
    APP_REGION: 'us',
    APP_VERSION: 34,
    BASE_HREF: '/d',
    LOG_LEVEL: 'debug',
    APP_URL: 'https://app-stage4.creately.com',
    APP_US_URL: 'https://app-stage4.creately.com',
    APP_EU_URL: 'https://app-eu-stage4.creately.com',
    APP_AU_URL: 'https://app-au-stage4.creately.com',
    SITE_URL: 'https://stage4.creately.com/',
    API_BASE_URL: 'wss://neutrino-stage4.creately.com/neutrino/stream',
    REST_API_BASE_URL: 'https://neutrino-stage4.creately.com/neutrino/service',
    FILE_API_BASE_URL: 'https://neutrino-stage4.creately.com/neutrino/files',
    MESSAGE_PROTOCOL_VERSION: 1,
    BASE_URL: 'https://app-stage4.creately.com/d',
    RESOURCE_LOCATION: 'https://resources-stage4.creately.com/',
    SHAPE_RESOURCE_BASE: 'shape/def/',
    LIBRARY_RESOURCE_BASE: 'shape/lib/',
    GRAVITY_LIBRARY_URL: 'https://auth-stage4.creately.com/js/gravity-3.2.5.js',
    USER_IMAGE_BASE_URL : 'https://s3.amazonaws.com/creately-user-profile-stage4/',
    SENTRY_ENDPOINT: 'https://54f05c2d49264e9092de8bd49d90ea53@sentry.io/1221305',
    LOADING_SPINNER_URL: 'https://mirror-resource.creately.dev/loading-spinner/',
    DIAGRAM_SVG_BASE_URL: 'https://neutrino-diagram-svg-stage4.s3.amazonaws.com/',
    CUSTOM_IMAGE_BASE_URL: 'https://s3.amazonaws.com/neutrino-custom-image-stage4/',
    ZENDESK_CONTACT_US_URL: false,
    COGNITO_LOGOUT_URL: 'https://createlystage.auth.us-east-1.amazoncognito.com/logout',
    COGNITO_CLIENT_ID: '3gmqn5q25g4e7r92gd41sd6h46',
    COGNITO_LOGOUT_REDIRECT_URL: 'https://stage.creately.com',
    CREATELY_ANALYTICS: false,
    CREATELY_ANALYTICSJS_URL: 'https://creately.com/static/js/creately-analytics-2.7.2.js',
    CREATELY_ANALYTICS_SCHEMA: 'iglu:com.creately/creately_app_events/jsonschema/1-0-0',
    GA_TRACKER: false,
    GA4_MEASUREMENT_ID: 'G-CCDVMNN28K',
    GA_TAG_MANAGER: false, // 'GTM-5RF68JT',
    MATOMO_ANALYTICS_URL: 'https://zyr83.creately.com',
    MATOMO_SITE_ID: '1',
    EVENT_TRACKER_CONFIG: [
        { name: 'crisp' },
        {
            name: 'sendinblue',
            allow: [
                'n.conversion.',
                'n.dialog.share.',
                'n.route.document.create.load',
                'n.creator.item',
                'n.creator.templates.click' ],
        },
        { name: 'ga4' },
        { name: 'hyperdx' },
        { name: 'matomo' },
    ],
    PLAN_PERM_ERROR_REDIRECT_URL: 'https://stage4.creately.com/plans/',
    PLAN_PAGE_URL: 'https://stage4.creately.com/plans/',
    PERSONAL_PURCHSAE_URL: 'https://stage4.creately.com/upgrade/personal/?period=y',
    TEAM_PURCHSAE_URL: 'https://stage4.creately.com/upgrade/team/?period=y&users=3',
    BUSINESS_PURCHASE_URL: 'https://stage4.creately.com/upgrade/business/?period=y&users=1',
    DIAGRAM_COMMUNITY_URL: 'https://stage.creately.com/community-templates',
    TEAM_PORTAL_URL: 'https://account-stage4.creately.com',
    DATADOG_COLLECTOR_TOKEN: false,
    PDF_EXPORT_URL: 'https://tools-stage4.creately.com/generate_pdf',
    SOURCE_CONFIG: {
        gdrive: {
            shareUrl: 'https://apistage4.creately.com/api/source/gdrive/share',
        },
    },
    DISABLE_WEBSOCKET_CONNECTION: false,
    GOOGLE_CUSTOM_SEARCH: {
        id: '012660921508659707786:l4gtwqs1yc7',
        url: 'https://www.googleapis.com/customsearch/v1',
    },
    FETCH_DATA_URL: 'https://apistage4.creately.com/api/util/fetch',
    PHOTON_URL: {
        HOST_NAME: 'photon-stage4.creately.com',
        PORT: '443',
    },
    TIPTAP_WS_URL: 'wss://tiptap-stage4.creately.com',
    PLUGIN_AXION_MANIFEST: 'https://internal-stage.creately.dev/axion/manifest.json',
    SVG_TO_RASTER_URL: 'https://tools-stage4.creately.com/generate_image',
    EMBED_ENDPOINT_URL: 'https://embed-stage4.creately.com',
    GRAPHQL_API_BASE_URL: 'https://apistage4.creately.com/api/v0',
    GOOGLE_ACCESS_TOKEN_URL: 'https://apistage4.creately.com/api/token/google',
    ZENDESK_KEY: false,
    ZENDESK_HELP_CENTER_URL: false,
    TEMPORARY_EMAIL_DOMAINS: [ '@temp.creately.com' ],
    SENDINBLUE_CLIENT_KEY: 'r0pd53ia0v7s4rakwxpmqysh',
    DEMO_EMAIL_VERIFY_URL: 'https://stage4.creately.com/demo/email/verify/',
    GOOGLE_PICKER: {
        clientId: '',
        developerKey: '',
        appId: '',
    },
    PARTNERSTACK_COUPON_CODES: 'PARTNERSTACK, ENT-SP-DS-160',
    CYCLR_API_COMMANDS_URL: 'https://pipe-stage4.creately.com/integration/cpaas/command',
    CYCLR_AUTH_DOMAIN: 'https://cpass.creately.com',
    WISTIA_PLAYER: 'https://fast.wistia.com/embed/medias/',
    CREATELY_SEARCH_BASE_URL: 'https://search-stage4.creately.com/v1',
    CREATELY_ENTITY_SEARCH_URL: 'https://search-stage4.creately.com/v1/search',
    TOOLTIP_STATIC_BASE_URL: 'https://tooltip-stage4.creately.com/',
    EXTERNAL_DIAGRAM_CONVERT_URL: 'https://tools-stage4.creately.com/external/diagram/converter',
    HYPERDX_TOKEN: '91ab7fca-4311-4651-8ee9-a12510caf292',
    HYPERDX_API_URL: 'https://otel-logs-hdx-stage.creately.com',
    TYPESENSE_API: 'https://yto45nc6xlbpsopo3lx3ycee7y0rlanl.lambda-url.us-east-1.on.aws/typesense',
    TYPESENSE_API_KEY_URL: 'https://apistage4.creately.com/api/integration/typesense/search-key',
    CRISP_CHAT: 'e8a1c3f1-a1ea-455c-a6c2-1dfe022f84a7',
    MY_ASKAI_ID: 'Lz7fZ2Qi3l861KbuoUkfkRIEzCMJ2B',
    COOKIE_DOMAIN: '.creately.com',
    IMAGE_PROXY : 'https://tools-stage.creately.com/image_proxy/proxy?url=',
};
